import React from 'react';
import { Modal, Form, message, Input, Button, Select } from 'antd';
import commonS from 'styles/common.module.less';
import { FormFieldEnum, FormInterface } from './types';
import s from './s.module.less';
import { REQUIRED_FIELD } from 'constants/common';
import { EInternalLinkType, TInternalLink } from 'types/operation';
import { ServerMeta } from 'types/common';
import { updateHelloKlairtyKlarityPageInternalLinkBatch } from 'api/operation';

type Props = {
    onCancel:()=>void
    item?:TInternalLink[] //for edit fun
    onSuccess?: ()=>void
    open?: boolean;
    title?: string;
    servicePageOptions?: ServerMeta[];
    targetSpecialty?: ServerMeta,
    pageId: number,
};

const EditOnlineServiceModal = (props:Props) => {
    const { onCancel, item, onSuccess, pageId, targetSpecialty, servicePageOptions, open, title } = props;
    const [form] = Form.useForm<FormInterface>();
    const [,forceUpdate] = React.useState({});
    const [submiting, setSubmiting] = React.useState(false);

    const [usedDictKeyStr, setUsedContentStr] = React.useState<string[]>([]);

    const onOk = async () => {
        try {
            setSubmiting(true);
            const formValues = await form.validateFields();
            const addData:TInternalLink[] = [];
            formValues[FormFieldEnum.LIST].forEach((formValue, inx) => {
                const add:TInternalLink = {
                    type: EInternalLinkType.HEALTHY_CARE_SERVICE,
                    linkTag: formValue.linkTag,
                    linkName: '',
                    linkUrl: '',
                    pageId: pageId!,
                    seq: inx,
                };
                addData.push(add);
            });

            const result = await updateHelloKlairtyKlarityPageInternalLinkBatch(addData, EInternalLinkType.HEALTHY_CARE_SERVICE, pageId!);
            if (!result.error) {
                message.success('Updated successfully');
                onSuccess?.();
            }
        } catch (e:any) {
            if (e.errorFields) {
                //form error
                return;
            }
            const msg = e?.toString?.() || 'data error';
            message.error(msg);
        } finally {
            setSubmiting(false);
        }
    };
    React.useEffect(() => {
        if (!open) {
            setUsedContentStr([]);
            form.resetFields();
        }
        if (item && open) {
            const _usedContentStr:string[] = [];
            form.setFieldsValue({
                [FormFieldEnum.LIST]: item?.map((i) => {
                    _usedContentStr.push(i.linkTag);
                    return {
                        id: i.id,
                        linkTag: i.linkTag,
                    };
                }),
            });
            setUsedContentStr(_usedContentStr);
            forceUpdate({});
        }
    }, [item, open]);

    const hasOption = servicePageOptions && servicePageOptions?.length > 0;

    return (
        <Modal
            title={title || 'Edit'}
            closable
            className={commonS.modalFixHeightWrap}
            width="550px"
            destroyOnClose
            onCancel={() => {
                onCancel?.();
            }}
            onOk={onOk}
            okText="Save"
            open={open}
            okButtonProps={{
                loading: submiting,
            }}
        >
            {
                !hasOption &&
                <div>No service pages under this specialt</div>
            }
            {
                hasOption &&
                <Form
                    form={form}
                    name="basic"
                    className={commonS.formStyle1}
                    initialValues={{ remember: true }}
                    autoComplete="off"
                    layout="vertical"
                >
                    <Form.List name="list">
                        {
                            (fields, { add, remove }) => {
                                return (
                                    <>
                                        {
                                            fields.map((field, index) => {
                                                const servicePageDictKey = form.getFieldValue(['list', field.name, 'linkTag']);
                                                const target = servicePageOptions?.find((sm:ServerMeta) => {
                                                    return sm.content === servicePageDictKey || sm.dictKey === servicePageDictKey;
                                                });
                                                const text = target ? `Online ${target?.content}` : '';

                                                const serviceList = servicePageOptions?.filter((sm:ServerMeta) => {
                                                    return !usedDictKeyStr.includes(sm.content) || sm.content === servicePageDictKey;
                                                });

                                                return (
                                                    <div className={s.module} key={field.name}>
                                                        <div className={s.rowHeader}>
                                                            <span>Link {index + 1}</span>
                                                            <Button
                                                                onClick={() =>
                                                                {
                                                                    const _newUsedCondition = [...usedDictKeyStr].filter((str) => str !== servicePageDictKey);
                                                                    setUsedContentStr(_newUsedCondition);
                                                                    remove(index);
                                                                }
                                                                }
                                                            >
                                                                Remove
                                                            </Button>
                                                        </div>
                                                        <div className={s.content}>
                                                            <div className={s.row}>
                                                                <div
                                                                    className={s.rowItem}
                                                                    style={{ width: '100%' }}
                                                                >
                                                                    <Form.Item
                                                                        label={`Service page under ${targetSpecialty?.content?.toLowerCase()}`}
                                                                        name={[field.name, 'linkTag']}
                                                                        validateFirst
                                                                        rules={[
                                                                            { required: true, message: REQUIRED_FIELD },
                                                                        ]}
                                                                    >
                                                                        <Select
                                                                            showSearch
                                                                            onChange={(val) => {
                                                                                const _newUsedCondition = [...usedDictKeyStr].filter((str) => str !== servicePageDictKey);
                                                                                if (!usedDictKeyStr.includes(val)) {
                                                                                    _newUsedCondition.push(val);
                                                                                }
                                                                                setUsedContentStr(_newUsedCondition);
                                                                            }}
                                                                        >
                                                                            {
                                                                                servicePageOptions?.map((sm:ServerMeta) => {
                                                                                    return (
                                                                                        <Select.Option
                                                                                            disabled={usedDictKeyStr.includes(sm.dictKey) && sm.dictKey !== servicePageDictKey}
                                                                                            key={sm.dictKey}
                                                                                            value={sm.dictKey}
                                                                                        >
                                                                                            {sm.content}
                                                                                        </Select.Option>
                                                                                    );
                                                                                })
                                                                            }
                                                                        </Select>
                                                                    </Form.Item>
                                                                </div>
                                                            </div>
                                                            <div className={s.row}>
                                                                <div
                                                                    className={s.rowItem}
                                                                    style={{ width: '100%' }}
                                                                >
                                                                    <div className={s.labelText}>Link name *</div>
                                                                    <Input value={text} disabled />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        }
                                        <div
                                            onClick={() => {
                                                add();
                                            }}
                                            className={s.addLinkBtn}
                                        >
                                            Add another link
                                        </div>
                                    </>
                                );
                            }
                        }
                    </Form.List>
                </Form>
            }
        </Modal>
    );
};

export default EditOnlineServiceModal;
